import React from "react";
import { RepasseSetorialDetailsPage } from "./repasseSetorialDetails.page";
import { RepasseSetorialDetailsProvider } from "./context/repasse-setorial-details-context";

export function RepasseSetorialDetailsFactory() {
    return (
        <RepasseSetorialDetailsProvider>
            <RepasseSetorialDetailsPage />
        </RepasseSetorialDetailsProvider>
    );
}
